'use client';
import { useRef } from 'react';
import { useWindowEventListener } from '../../hooks/useWindowEventListener.js';
export function BeforeUnload({ message }) {
    const currentMessage = useRef(message);
    // eslint-disable-next-line react-hooks/refs
    currentMessage.current = message;
    useWindowEventListener('beforeunload', (event) => {
        event.returnValue = currentMessage.current;
    });
    return null;
}
//# sourceMappingURL=BeforeUnload.js.map